module.exports = __webpack_public_path__ + "static/media/background.17c2afe8.png";